// UTM parameter tracking without cookies
// This tracks campaign performance using URL parameters and session storage

/**
 * Extract UTM parameters from URL
 */
export const getUTMParameters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    utm_source: urlParams.get('utm_source'),
    utm_medium: urlParams.get('utm_medium'),
    utm_campaign: urlParams.get('utm_campaign'),
    utm_term: urlParams.get('utm_term'),
    utm_content: urlParams.get('utm_content'),
    gclid: urlParams.get('gclid'), // Google Ads click ID
    fbclid: urlParams.get('fbclid'), // Facebook click ID
  };
};

/**
 * Store UTM parameters in session storage (no cookies needed)
 */
export const captureUTMParameters = () => {
  const utmParams = getUTMParameters();
  
  // Only store if we have UTM parameters
  if (Object.values(utmParams).some(value => value !== null)) {
    sessionStorage.setItem('utm_parameters', JSON.stringify(utmParams));
    sessionStorage.setItem('utm_captured_at', new Date().toISOString());
    
    // Also store the landing page
    sessionStorage.setItem('landing_page', window.location.href);
  }
  
  return utmParams;
};

/**
 * Get stored UTM parameters (for attribution)
 */
export const getStoredUTMParameters = () => {
  try {
    const stored = sessionStorage.getItem('utm_parameters');
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.warn('Error retrieving UTM parameters:', error);
    return {};
  }
};

/**
 * Track campaign performance without cookies
 */
export const trackCampaignPerformance = (event, additionalData = {}) => {
  const utmParams = getStoredUTMParameters();
  const landingPage = sessionStorage.getItem('landing_page');
  const capturedAt = sessionStorage.getItem('utm_captured_at');
  
  // Send to your analytics endpoint
  return {
    event: event,
    ...utmParams,
    landing_page: landingPage,
    campaign_captured_at: capturedAt,
    current_page: window.location.href,
    timestamp: new Date().toISOString(),
    ...additionalData
  };
};

/**
 * Initialize UTM tracking on page load
 */
export const initializeUTMTracking = () => {
  // Capture UTM parameters on page load
  const utmParams = captureUTMParameters();
  
  // If we have UTM parameters, send them to analytics
  if (Object.values(utmParams).some(value => value !== null)) {
    console.log('UTM parameters captured:', utmParams);
    
    // You can send this to your server-side analytics
    // trackServerSideEvent(trackCampaignPerformance('campaign_landing'));
  }
};
